import {connect} from '@gisatcz/ptr-state';
import Select from '../../../../../state/Select';

import presentation from '../../../../common/AttributeListing';

const mapStateToProps = (state, ownProps) => {
	return {
		data: Select.insar.getDataForZonesAttributeListing(
			state,
			ownProps.featureProperties
		),
	};
};

export default connect(mapStateToProps)(presentation);
